import React, { createContext } from 'react';

// 创建一个上下文对象，设置默认值为 null
const SharedDataContext = createContext<any>({});

export default SharedDataContext;